var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "none",
    clipRule: "evenodd",
    d: "M19.75 10C19.75 15.3848 15.3848 19.75 10 19.75C4.61522 19.75 0.25 15.3848 0.25 10C0.25 4.61522 4.61522 0.25 10 0.25C15.3848 0.25 19.75 4.61522 19.75 10ZM9.75 15.75C10.3023 15.75 10.75 15.3023 10.75 14.75C10.75 14.1977 10.3023 13.75 9.75 13.75C9.19771 13.75 8.75 14.1977 8.75 14.75C8.75 15.3023 9.19771 15.75 9.75 15.75ZM10.7501 12.75V12.05C10.7501 11.3877 11.2179 10.9399 11.7405 10.4396C12.4015 9.80691 13.1501 9.09035 13.1501 7.75C13.1501 6.35 12.1501 4.75 9.7501 4.75C6.9501 4.75 6.3501 6.85 6.3501 8.25H8.2501C8.26397 8.20839 8.27784 8.14562 8.29491 8.06836C8.40092 7.58857 8.63041 6.55 9.7501 6.55C10.4501 6.55 11.1501 7.05 11.1501 7.95C11.1501 8.63387 10.6304 9.08679 10.0738 9.572C9.89783 9.72534 9.7182 9.8819 9.5501 10.05C8.8501 10.75 8.7501 11.55 8.7501 12.15V12.75H10.7501Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpCircle);
export default __webpack_public_path__ + "static/media/icon-help-circle.bfec6eefaaf36dc675424ff612408159.svg";
export { ForwardRef as ReactComponent };